import React from "react";
import InfoHelp from "./InfoHelp";

/**
 * ServiceFeeInfo — the "Service fee" label on every buyer-facing checkout summary: a
 * short always-visible hint plus a help icon opening the fuller explanation (InfoHelp).
 * Drop-in for the label cell; the amount cell is untouched. Pass `labelStyle` on
 * inline-style rows (BookingPayment / GuestBookingPayment).
 *
 * 🚨 Buyer-facing copy: never call the fee an estimate, never mention card type or card
 * country, and never surface pricing.rateTier / rateCurrency. The total is fixed at
 * checkout and is the same whichever card is used.
 */
const ServiceFeeInfo = ({ className = "", labelStyle }) => (
    <InfoHelp
        label="Service fee"
        hint="Covers platform and payment processing costs."
        title="About the service fee"
        ariaLabel="About the service fee"
        className={`service-fee-info ${className}`.trim()}
        labelStyle={labelStyle}>
        <p>This fee covers the cost of running the platform and processing your payment securely through Stripe.</p>
    </InfoHelp>
);

export default ServiceFeeInfo;
